module.exports = __webpack_public_path__ + "img/_54A6743.df45cc87.jpg";